import React from 'react';

export interface LoadingStateProps {
  text?: string;
  className?: string;
  fullscreen?: boolean;
}

export const LoadingState = ({ text = 'Đang tải dữ liệu...', className = '', fullscreen = false }: LoadingStateProps) => {
  const content = (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div className="w-8 h-8 border-2 border-brand-200 border-t-brand-600 rounded-full animate-spin mb-3"></div>
      <p className="sm:text-sm text-xs text-slate-500">{text}</p>
    </div>
  );

  if (fullscreen) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
        {content}
      </div>
    );
  }

  return content;
};
